import React, { lazy, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasPublicReportWebsiteSearch } from './utils/publicReportUrl.js';

const HomePage = lazy(() => import('./pages/HomePage.jsx'));

export default function HomeEntry() {
  const location = useLocation();

  // Legacy public report links used `/?website=…` — send them to grants-section.
  if (hasPublicReportWebsiteSearch(location.search)) {
    return <Navigate to={`/grants-section${location.search}${location.hash || ''}`} replace />;
  }

  return (
    <Suspense fallback={<div className="loading-spinner-container"><div className="loading-spinner" /></div>}>
      <HomePage />
    </Suspense>
  );
}
